import EmptyRecord from '@/components/EmptyRecord';
import styles from '../styles/index.less';

const RecuritEmptyPage = ({ onRefresh }) => {
  return (
    <EmptyRecord className={styles['none-biz']} img="recruit/apply/no_data.png" text="">
      <div className={styles.emptyContent}>
        <p>啊呀，暂未获取到数据</p>
        <p>
          您可以<span onClick={onRefresh}>刷新重试</span>
        </p>
      </div>
    </EmptyRecord>
  );
};
export default RecuritEmptyPage;
